export default "__VITE_ASSET__yjI2tHsF__"